if (!customElements.get("ff-header-drawer")) {
  /**
   * Función utilitaria para esperar a que un elemento esté disponible en el DOM
   */
  function waitForElement(selector, timeout = 5000) {
    return new Promise((resolve, reject) => {
      const element = document.querySelector(selector);
      console.log(element)
      if (element) {
        resolve(element);
        return;
      }

      const observer = new MutationObserver((mutations) => {
        const element = document.querySelector(selector);
        if (element) {
          observer.disconnect();
          resolve(element);
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Timeout fallback
      setTimeout(() => {
        observer.disconnect();
        const element = document.querySelector(selector);
        if (element) {
          resolve(element);
        } else {
          reject(new Error(`Elemento ${selector} no encontrado después de ${timeout}ms`));
        }
      }, timeout);
    });
  }

  /**
   * This extension of HeaderDrawer is meant to change the flow of the menu,
   * to implement the FfCollapsable for the menu groups.
   *
   * FLOW TO REMOVE IPHONE SCROLL
   * block pointer and touch-actions in the whole page
   * animate the opening of menu
   * change the body to fixed position and give it a negative transform to hide the announcement bar
   * enable pointer and touch-actions in ff-header-drawer
   */
  class FfMenuDrawer extends HeaderDrawer {
    constructor() {
      super();
      this.collapsables = this.querySelectorAll("ff-collapsable");
      this.ffBindedBlock = this.ffBlockScroll.bind(this);

      this.querySelector("#menu-drawer").addEventListener(
        "transitionstart",
        () => (this.transitionStart = true)
      );
    }

    closeAnimation(detailsElement) {
      const collapsableContainer = detailsElement.querySelector(
        ".ff-facet_collapsable-container"
      );
      if (collapsableContainer && this.mainDetailsToggle != detailsElement) {
        collapsableContainer.removeEventListener("transitionend", closeFacet);
        collapsableContainer.addEventListener("transitionend", closeFacet);

        function closeFacet() {
          collapsableContainer.removeEventListener("transitionend", closeFacet);

          detailsElement.removeAttribute("open");
          if (detailsElement.closest("details[open]")) {
            trapFocus(
              detailsElement.closest("details[open]"),
              detailsElement.querySelector("summary")
            );
          }
        }
      } else {
        let animationStart;
        const handleAnimation = (time) => {
          if (animationStart === undefined) {
            animationStart = time;
          }

          const elapsedTime = time - animationStart;

          if (elapsedTime < 400) {
            window.requestAnimationFrame(handleAnimation);
          } else {
            detailsElement.removeAttribute("open");
            if (detailsElement.closest("details[open]")) {
              trapFocus(
                detailsElement.closest("details[open]"),
                detailsElement.querySelector("summary")
              );
            }
            setTimeout(() => {
              document.body.classList.remove(
                `overflow-hidden-${this.dataset.breakpoint}`
              );
            }, 100);
          }
        };

        window.requestAnimationFrame(handleAnimation);
      }
    }

    /**
     * The original closeMenuDrawer was also closing all the opened details elements,
     * in FfMenuDrawer that is done in the method onSmmaryClick instead.
     */
    closeMenuDrawer(event, elementToFocus = false) {
      if (event === undefined) return;
      setTimeout(() => {
        this.mainDetailsToggle.classList.remove("menu-opening");
        removeTrapFocus(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);

        // Mostrar elementos cuando se cierra el menú
        this.showWidgetElements();

        if (event instanceof KeyboardEvent)
          elementToFocus?.setAttribute("aria-expanded", false);
      }, 100);
    }

    openMenuDrawer(summaryElement) {
      setTimeout(() => {
        if (this.transitionStart) {
          this.querySelector("#menu-drawer").removeEventListener(
            "transitionend",
            this.ffBindedBlock
          );
          this.querySelector("#menu-drawer").addEventListener(
            "transitionend",
            this.ffBindedBlock
          );
          this.transitionStart = false;
        } else {
          this.ffBindedBlock();
        }

        // Ocultar elementos cuando se abre el menú
        this.hideWidgetElements();

        super.openMenuDrawer(summaryElement);
      }, 10);
    }

    ffBlockScroll() {
      this.classList.add("ff-enable-pointer");
      this.querySelector("#menu-drawer").removeEventListener(
        "transitionend",
        this.ffBindedBlock
      );
      
    }

    ffResumeScroll() {
      this.classList.remove("ff-enable-pointer");
      if (this.pageScrollBackUp > 0) {
        document.body.style.position = this.bodyPositionBackUp;
        document.body.style.transform = this.bodyTransformBackUp;
        document.querySelector("html").scrollTop = this.pageScrollBackUp;
        this.pageScrollBackUp = 0;
      }
    }

    onSummaryClick(e) {
      this.ffCloseCollapsables();
      super.onSummaryClick(e);
      this.querySelector(".menu-drawer__navigation-container").scrollTo(0, 0);
    }

    ffCloseCollapsables() {
      this.collapsables.forEach((collapsable) => {
        const closeBtn = collapsable.querySelector(".ff-close-facet");
        if (collapsable.isOpened && closeBtn) {
          closeBtn.click();
        }
      });
    }

    // Configuración de widgets a manejar
    getWidgetSelectors() {
      return [
        { selector: ".kl-teaser-VPKpgW", name: "Klaviyo promo" },
        { selector: "#launcher", name: "Zendesk" }
      ];
    }

    // Función genérica para manejar la visibilidad de un widget
    async handleWidgetElement(widgetConfig, displayValue, action) {
      try {
        const element = await waitForElement(widgetConfig.selector, 2000);
        element.style.display = displayValue;
      } catch (error) {
        console.log(`Elemento ${widgetConfig.name} no encontrado:`, error.message);
      }
    }

    // Función optimizada para ocultar widgets
    async hideWidgetElements() {
      const widgets = this.getWidgetSelectors();
      
      // Procesar todos los widgets en paralelo
      await Promise.all(
        widgets.map(widget => this.handleWidgetElement(widget, "none", "ocultado"))
      );
    }

    // Función optimizada para mostrar widgets
    async showWidgetElements() {
      const widgets = this.getWidgetSelectors();
      
      // Procesar todos los widgets en paralelo
      await Promise.all(
        widgets.map(widget => this.handleWidgetElement(widget, "", "mostrado"))
      );
    }
  }

  customElements.define("ff-header-drawer", FfMenuDrawer);
}
